export const LENGTH_UNITS = {
  KILOMETERS: "kilometers",
  METERS: "meters",
  MILES: "miles",
  YARDS: "yards",
  FEET: "feet"
};

